import { createAsyncThunk, createSlice, isPending } from '@reduxjs/toolkit';
import { TireAlertsInfoResponse, TireAlertType, TireIndicatorsKpis, } from 'app/shared/model/tire-indicators.model';
import axios from 'axios';

const initialState = {
  loadingKpis: false,
  loadingAlertsInfo: false,
  errorMessage: null,
  tireIndicatorsKpis: null as TireIndicatorsKpis | null,
  tireAlertsInfo: [] as TireAlertsInfoResponse,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type TireIndicatorsSlice = Readonly<typeof initialState>;

const apiUrl = 'api/tire-indicators';

interface GetTireIndicatorsKpisParams {
  companyId?: number;
}

export const getTireIndicatorsKpis = createAsyncThunk(
  'tireIndicators/getTireIndicatorsKpis',
  async ({ companyId }: GetTireIndicatorsKpisParams) => {
    const queryParams = new URLSearchParams();

    if (companyId !== undefined && companyId !== null) {
      queryParams.append('searchCompanyId', companyId.toString());
    }

    const requestUrl = `${apiUrl}/kpis?${queryParams.toString()}`;

    return axios.get<TireIndicatorsKpis>(requestUrl);
  }
);

interface GetTireAlertsParams {
  tireAlertType: TireAlertType;
  companyId?: number;
}

export const getTireAlerts = createAsyncThunk(
  'tireIndicators/getTireAlerts',
  async ({ tireAlertType, companyId }: GetTireAlertsParams) => {
    const queryParams = new URLSearchParams();

    if (companyId !== undefined && companyId !== null) {
      queryParams.append('searchCompanyId', companyId.toString());
    }

    const requestUrl = `${apiUrl}/alerts-info/${tireAlertType}?${queryParams.toString()}`;

    return axios.get<TireAlertsInfoResponse>(requestUrl);
  }
);

export const TireIndicatorsSlice = createSlice({
  name: 'tireIndicators',
  initialState: initialState as TireIndicatorsSlice,

  reducers: {
    reset() {
      return initialState;
    },

    resetTireAlertsInfo(state) {
      state.tireAlertsInfo = [];
      state.loadingAlertsInfo = false;
      state.errorMessage = null;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(getTireIndicatorsKpis.fulfilled, (state, action) => {
        state.loadingKpis = false;
        state.tireIndicatorsKpis = action.payload.data;
      })
      .addCase(getTireAlerts.fulfilled, (state, action) => {
        state.loadingAlertsInfo = false;
        state.tireAlertsInfo = action.payload.data;
      })
      .addMatcher(isPending(getTireIndicatorsKpis), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loadingKpis = true;
      })
      .addMatcher(isPending(getTireAlerts), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loadingAlertsInfo = true;
      });
  },
});

export const {
  reset,
  resetTireAlertsInfo,
} = TireIndicatorsSlice.actions;

export default TireIndicatorsSlice.reducer;